<template>
    <v-card>
        <v-list three-line>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        <strong class="subheading">
                            {{ customer.name }}
                            <span class="red--text" v-if="customer.deleted_at">Arkivert</span>
                        </strong>
                        <small class="grey--text" v-if="customer.customer_number">&nbsp;(#{{
                                customer.customer_number
                            }})
                        </small>
                    </v-list-item-title>
                    <v-list-item-subtitle class="mb-2">
                        <span v-if="car && car.contact_name !== customer.name">{{ car.contact_name }} -</span>
                        <strong class="purple--text" v-if="customer.is_company">Bedriftskunde</strong>
                        <strong class="green--text" v-else>Privatkunde</strong>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="mb-2" v-if="customer.category_id">
                        <strong>{{ customer.category.name }}</strong>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="customer.address || customer.zip_code || customer.city">
                        {{ customer.address }}, {{ customer.zip_code }} {{ customer.city }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-card-text v-if="customer.note" class="pt-0">
            {{ customer.note }}
        </v-card-text>
        <v-card-actions class="grey lighten-4">
            <v-btn text :href="`tel:${car.contact_phone}`" color="blue-grey"
                   v-if="car && car.contact_phone && customer.phone !== car.contact_phone">
                <v-icon left>phone</v-icon>
                {{ car.contact_phone }} ({{ car.contact_name }})
            </v-btn>
            <v-btn text :href="`tel:${customer.phone}`" color="blue-grey" v-else-if="customer.phone">
                <v-icon left>phone</v-icon>
                {{ customer.phone }}
            </v-btn>
            <v-btn text :href="`mailto:${customer.email}`" color="blue-grey" v-if="customer.email">
                <v-icon left> mail</v-icon>
                Send epost
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        customer: {},
        car: {}
    }
}
</script>
